"use strict";

exports.__esModule = true;
exports.default = isFinite;
var _setup = require("./_setup.js");
var _isSymbol = _interopRequireDefault(require("./isSymbol.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Is a given object a finite number?
function isFinite(obj) {
  return !(0, _isSymbol.default)(obj) && (0, _setup._isFinite)(obj) && !isNaN(parseFloat(obj));
}